import React, { useEffect, useRef, useState } from 'react'
import { UserSocialProfile } from '../redux/slices/userSlice'
import { API } from './API'
import { LoginProvider } from './LoginProvider'
import { jwtDecode } from 'jwt-decode'
import { useAppDispatch, useAppSelector } from '../redux/hooks'
import { closeModal } from '../redux/slices/modalSlice'
import { useNavigate } from 'react-router-dom'


interface CredentialDecoded {
	iss: string // "https://accounts.google.com", // The JWT's issuer
	nbf: number // 161803398874,
	aud: string // "314159265-pi.apps.googleusercontent.com", // Your server's client ID
	sub: string // "3141592653589793238", // The unique ID of the user's Google Account
	hd: string // "gmail.com", // If present, the host domain of the user's GSuite email address
	email: string // "elisa.g.beckett@gmail.com", // The user's email address
	email_verified: boolean // true, // true, if Google has verified the email address
	azp: string // "314159265-pi.apps.googleusercontent.com",
	name: string // "Elisa Beckett",
	picture: string // "https://lh3.googleusercontent.com/a-/e2718281828459045235360uler",
	given_name: string // "Elisa",
	family_name: string // "Beckett",
	iat: number // 1596474000, // Unix timestamp of the assertion's creation time
	exp: number // 1596477600, // Unix timestamp of the assertion's expiration time
	jti: string // "abc161803398874def"
}

const LoginGGL: React.FC = () => {
	const dispatch = useAppDispatch()
	const {modalProps:{routing,deeplink}} = useAppSelector((state) => state.modal)
	const [gsiScriptLoaded, setGsiScriptLoaded] = useState(false)
	const refButton = useRef<HTMLDivElement>(null)
	const navigate = useNavigate()

	useEffect(() => {
		if (gsiScriptLoaded) return

		const initializeGsi = () => {
			if (!window.google || gsiScriptLoaded) return

			setGsiScriptLoaded(true)
			window.google.accounts.id.initialize({
				client_id: '259966498344-spl923rp3lgokku9km7jckaj5s8ndin8.apps.googleusercontent.com',
				callback: async (res: CredentialResponse) => {
					if (!res.clientId || !res.credential) return
					const crd: CredentialDecoded = jwtDecode(res.credential)
					const profile: UserSocialProfile = {
						firstName: crd.given_name,
						lastName: crd.family_name,
						name: crd.name,
						picture: crd.picture,
						original: crd,
					}

					try {
						await API.processSocialLogin(LoginProvider.GGL, crd.sub, res.credential, crd.email, profile)
						routing && navigate(routing.pathname)
				        deeplink && deeplink()
						dispatch(closeModal())
					} catch (error) {
						console.error('Failed to process social login:', error)
					}
				},
			})

			window.google.accounts.id.renderButton(refButton.current!, {
				type: 'standard',
				theme: 'outline', // Change to outline theme
				size: 'medium',
				shape: 'rectangular', // Rectangular shape (you can adjust corners with CSS)
				text: 'continue_with', // This shows "Continue with Google" text
				logo_alignment: 'left', // Google logo on the left
				width: '252', // Set width for the button
				// className: 'ggl-login-button', // Add custom CSS class to the button
			})
		}

		const script = document.createElement('script')
		script.src = 'https://accounts.google.com/gsi/client'
		script.onload = initializeGsi
		script.async = true
		script.id = 'google-client-script'
		document.querySelector('body')?.appendChild(script)

		return () => {
			window.google?.accounts.id.cancel()
			document.getElementById('google-client-script')?.remove()
		}
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [gsiScriptLoaded])

	if (gsiScriptLoaded || true) {
		return (
			<>
				<div className="ggl-button-hidden" ref={refButton} style={{ opacity: 0, display: 'inline-block' }} />
				<div className="ggl-button">
					<div className="ggl-icon"></div>
					Continue with Google
				</div>
			</>
		)
	} else {
		return null
	}
}

export { LoginGGL }
